import './CTLG.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CTLG extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initFacets();
	}

	async initFacets () {
		const facetsContainerElement = document.getElementById('js-facets');

		if (!facetsContainerElement) {
			return;
		}

		const {Facets} = await import('extensions/facets');

		new Facets(facetsContainerElement);
	}
}
